import React from "react";
import Carousel from 'components/Carousel';
import { ReactComponent as LeftSide } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightSide } from "images/background/right-box-graphic.svg";

const Howgoopter = () => {
  return (
    <section className="howGoopter">
    <LeftSide className="hg-bg4" />
    <RightSide className="hg-bg3" />
      <div className="container">
        <Carousel id="carouselData" />
      </div>
    </section>
  );
};

export default Howgoopter;
